import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {DataService} from '../../../../_services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-svg-loader',
    template: `
        <div [innerHtml]="sanitizedSvg" *ngIf="sanitizedSvg"></div>`,
    styleUrls: ['./svg-loader.component.scss']  // Path to your SCSS file
})
export class SvgLoaderComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() svgUrl: string;
    sanitizedSvg: SafeHtml;
    appartments: any;
    private scale = 1; // Initial scale
    private isDragging = false;
    private dragStartX = 0;
    private dragStartY = 0;
    private elementStartX = 0;
    private elementStartY = 0;
    private currentBuildingSubscriber: Subscription;
    private currentUnitSubscriber: Subscription;
    lastNewX: number = 0;
    lasrNewY: number = 0;
    private readonly minScale = 1; // Minimum scale (50% of the original size)
    private readonly maxScale = 2.5;   // Maximum scale (300% of the original size)
    private wasDragged = false; // New flag to track if dragging occurred
    particularUnit: boolean = false;


    constructor(private http: HttpClient, private sanitizer: DomSanitizer, private renderer: Renderer2,
                public dataService: DataService, private route: ActivatedRoute, private router: Router, private el: ElementRef,) {
    }

    ngOnInit() {
        if (this.svgUrl) {
            // 1 aproach
            // this.loadSvg(this.svgUrl);
            if (this.route.snapshot.params.flatId || this.route.snapshot.params.userId) {
                this.particularUnit = true;
            }
            if (this.particularUnit) {
                this.currentUnitSubscriber = this.dataService.currentUnit.subscribe(item => {
                    if (item) {
                        this.appartments = [];
                        this.appartments.push(item);
                        console.log(this.appartments);
                    } else {
                        console.log('No item available yet');

                    }
                });
            } else {
                this.currentBuildingSubscriber = this.dataService.currentBuilding.subscribe(item => {
                    if (item) {
                        if (item.floors) {
                            this.appartments = item.floors[0].floor.flats;
                        } else {
                            this.appartments = item;
                        }

                        console.log(this.appartments);
                    } else {
                        console.log('No item available yet');
                    }
                })
            }


            this.loadAndEditSvg(this.svgUrl);
        }
    }

    ngAfterViewInit(): void {
        if (this.particularUnit) {
            this.addEventListeners();
            return;
        }
        // Add event listeners after the SVG is rendered in the DOM
        console.log("SVG DOMA")
        setTimeout(() => {
            this.appartments.forEach(item => {
                console.log('-------------------------------------', item);
                const className = `name-${item.number}`;
                const element = document.querySelector(`.${className}`);
                if (element) {
                    this.renderer.listen(element, 'mouseenter', () => {
                        this.dataService.markerUnitOnHoverSVG(item.number);
                    });
                    this.renderer.listen(element, 'mouseleave', () => {
                        this.dataService.markerUnitOnHoverSVG('');
                    });
                    if (item.status !== 'sold') {
                        this.renderer.listen(element, 'click', () => {
                            if (this.wasDragged) {
                                return;
                            }
                            this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + item.id]);

                        });
                    }
                }
            });
            this.addEventListeners();
        }, 3000);
    }

    // 1aproach
    // loadSvg(url: string) {
    //   this.http.get(url, { responseType: 'text' }).subscribe(
    //     svg => {
    //       this.sanitizedSvg = this.sanitizer.bypassSecurityTrustHtml(svg);
    //       console.log(this.sanitizedSvg);
    //     },
    //     error => {
    //       console.error('Error loading SVG:', error);
    //     }
    //   );
    // }
    loadAndEditSvg(url: string): void {
        this.http.get(url, {responseType: 'text'}).subscribe(
                svgContent => {
                    const modifiedSvg = this.modifySvg(svgContent);
                    this.sanitizedSvg = this.sanitizer.bypassSecurityTrustHtml(modifiedSvg);
                    setTimeout(() => this.addEventListeners(), 0);
                },
                error => {
                    console.error('Error loading SVG:', error);
                }
        );
    }

    addEventListeners(): void {
        const svgElement = this.el.nativeElement.querySelector('svg');

        if (svgElement) {
            // Mouse wheel event for resizing
            this.renderer.listen(svgElement, 'wheel', (event: WheelEvent) => {
                event.preventDefault();
                this.handleWheelEvent(event, svgElement);
            });

            // Mouse events for dragging
            this.renderer.listen(svgElement, 'mousedown', (event: MouseEvent) => this.startDrag(event, svgElement));
            this.renderer.listen(document, 'mousemove', (event: MouseEvent) => this.drag(event, svgElement));
            this.renderer.listen(document, 'mouseup', () => {
                this.endDrag(svgElement)
            });
        }
    }

    handleWheelEvent(event: WheelEvent, svgElement: SVGSVGElement): void {
        const scaleAmount = 0.1;
        if (event.deltaY < 0) {
            // Scrolling up, zoom in
            this.scale = Math.min(this.scale + scaleAmount, this.maxScale); // Ensure scale does not exceed maxScale
        } else {
            // Scrolling down, zoom out
            // this.scale -= scaleAmount;
            this.scale = Math.max(this.scale - scaleAmount, this.minScale); // Ensure scale does not go below minScale
        }

        // Apply the scale to the SVG element
        svgElement.setAttribute('transform', `translate(${+this.lastNewX}, ${+this.lasrNewY}) scale(${this.scale})`);
    }

    startDrag(event: MouseEvent, svgElement: SVGSVGElement): void {
        event.preventDefault();
        this.isDragging = true;
        this.wasDragged = false; // Reset drag flag when drag starts

        const point = this.getSVGPoint(event, svgElement);
        this.dragStartX = point.x;
        this.dragStartY = point.y;

        const transform = svgElement.getAttribute('transform') || '';
        const translateMatch = /translate\(([^)]+)\)/.exec(transform);
        if (translateMatch) {
            const [x, y] = translateMatch[1].split(',').map(parseFloat);
            this.elementStartX = x;
            this.elementStartY = y;
        } else {
            this.elementStartX = 0;
            this.elementStartY = 0;
        }
    }

    drag(event: MouseEvent, svgElement: SVGSVGElement): void {
        if (!this.isDragging) return;

        this.wasDragged = true; // Set flag indicating a drag occurred

        svgElement.classList.add("draggable");
        const point = this.getSVGPoint(event, svgElement);
        const dx = point.x - this.dragStartX;
        const dy = point.y - this.dragStartY;

        const newX = this.elementStartX + dx;
        const newY = this.elementStartY + dy;

        this.lastNewX = newX;
        this.lasrNewY = newY;
        svgElement.setAttribute('transform', `translate(${newX}, ${newY}) scale(${this.scale})`);
    }

    endDrag(svgElement): void {
        svgElement.classList.remove("draggable");
        this.isDragging = false;
    }

    getSVGPoint(event: MouseEvent, svgElement: SVGSVGElement): DOMPoint {
        const point = svgElement.createSVGPoint();
        point.x = event.clientX;
        point.y = event.clientY;
        return point;
    }


    modifySvg(svgContent: string): string {
        const parser = new DOMParser();
        const svgDocument = parser.parseFromString(svgContent, 'image/svg+xml');

        const elementsToFill = svgDocument.querySelectorAll('.name-1');

        this.appartments.forEach(item => {
            let className = `name-${item.number}`;
            let element = svgDocument.querySelectorAll(`.${className}`);
            let elementStatus = item.status;
            if (this.particularUnit) {
                if (element[0]) {
                    element[0].classList.add(elementStatus);
                    element[0].classList.add('current');
                }
                return
            }
            if (element[0]) {
                element[0].classList.add(elementStatus);
            }
        });
        const serializer = new XMLSerializer();
        return serializer.serializeToString(svgDocument);
    }

    // addChanges(element, appartment, classStatus){
    //   // svgElements.forEach((element: any) => {
    //     element.classList.add(classStatus);
    //     element.addEventListener('click', () => {
    //       // console.log('Element clicked:', element);
    //       // this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + element.id]);
    //       // You can also perform other actions here
    //     // });
    //   });
    // }

    ngOnDestroy() {
        this.currentUnitSubscriber && this.currentUnitSubscriber.unsubscribe();
        this.currentBuildingSubscriber && this.currentBuildingSubscriber.unsubscribe();
    }
}
